import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const trackFeatureAppReady = (trackingService: TrackingServiceV2) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'feature_app_ready',
          eventName: 'vtp highlights - feature app ready',
        },
        attributes: {
          componentName: 'vtp-highlights',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: '',
          value: '',
          pos: '',
        },
      },
      componentUpdate: {
        attributes: {
          implementer: 2,
        },
      },
    });
  }
};

export const registerImpressionTracking = (trackingService: TrackingServiceV2, ref: any) => {
  if (trackingService) {
    if (ref !== null) {
      trackingService.registerImpressionTracking(ref.current, () => {
        return {
          event: {
            eventInfo: {
              eventAction: 'impression',
              eventName: 'vtp highlights - impression',
            },
            attributes: {
              componentName: 'vtp-highlights',
              label: '',
              targetURL: '',
              clickID: '',
              elementName: '',
              value: '',
              pos: '',
            },
          },
        };
      });
    }
  }
};

export const trackLayerLinkClick = (trackingService: TrackingServiceV2, label: string) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'internal_link',
          eventName: 'vtp highlights - open emission layer',
        },
        attributes: {
          componentName: 'vtp-highlights',
          label,
          targetURL: '',
          clickID: '',
          elementName: 'text link',
          value: '',
          pos: '',
        },
      },
    });
  }
};

export const trackLayerOpen = (trackingService: TrackingServiceV2, infoLink: string) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: infoLink.startsWith(window.location.origin) ? 'internal_link' : 'exit_link',
          eventName: 'vtp highlights - open audi gw:plus layer',
        },
        attributes: {
          componentName: 'vtp-highlights',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: 'icon',
          value: '',
          pos: '',
        },
      },
    });
  }
};
